import React from "react";
import { useAuth } from "shared/context/auth";
import { useQueryClient } from "react-query";
import { refreshDashboardData } from "apps/myExperience/context/dashboard/dataloader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MyExpRoute } from "apps/myExperience/routes/types";

export default function useBulkTicketManagementRouteService() {
  const navigate = useNavigate();
  const { userDetail } = useAuth();
  const queryClient = useQueryClient();
  const [searchParams] = useSearchParams();

  const navigateToDashboard = React.useCallback(() => {
    navigate({
      pathname: MyExpRoute.HOME.path,
      search: searchParams.toString()
    });
  }, [navigate, searchParams]);

  const closeHandler = React.useCallback(() => {
    navigateToDashboard();
    refreshDashboardData(queryClient, userDetail?.id);
  }, [navigateToDashboard, queryClient, userDetail?.id]);

  return {
    closeHandler
  };
}
